import script from "./DistanceHistogram.vue?vue&type=script&setup=true&lang=js"
export * from "./DistanceHistogram.vue?vue&type=script&setup=true&lang=js"

import "./DistanceHistogram.vue?vue&type=style&index=0&id=4290be9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4290be9d"]])

export default __exports__